import { ArrowLeftToLine  } from 'lucide-react';

export default function error() {


    return (
        <div
            className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6"
            style={{ backgroundImage: "url('/images/bg.jpg')" }}>
            <img src="/images/logo.png" alt="logo" className="max-w-[100px] mb-[20px]" />
<h1 className='text-5xl font-black'>404</h1>
            <p className="text-base mb-5 max-w-[1000px] leading-[2em]">
                Page not found!
            </p>

            <div className="flex">
                <a href='/home'>
                    <div className="flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-sm border-2 border-blue-500">
                        <ArrowLeftToLine  size={20} />
                        <button>
                            Back To Home
                        </button>
                    </div></a>

               
            </div>

        </div>
    );
}